import { memo, ReactElement } from 'react';
import isArray from 'lodash-es/isArray';

import {
  getCardsContainerGridColumnsClass,
  groupNonCampaignCards,
  isCampaignCard,
} from '../megaMenuUtils';
import { useHeaderNavigation } from '../providers';
import { BigCard } from './BigCard';
import { Campaigns } from './Campaigns';
import { SmallCardsGroup } from './SmallCardsGroup';

import styles from './Cards.module.css';

export const MajorLinkCards = memo(function MajorLinkCards(): ReactElement | null {
  const { activeMajorLink, cards: commonCards } = useHeaderNavigation();

  if (!activeMajorLink) {
    return null;
  }

  const cards = activeMajorLink.cardIds?.length
    ? activeMajorLink.cardIds.flatMap((id) => (commonCards?.[id] ? [commonCards[id]] : []))
    : activeMajorLink.Cards;

  if (!cards || cards.length === 0) {
    return null;
  }

  const campaigns = cards.filter((card) => isCampaignCard(card));
  const nonCampaigns = groupNonCampaignCards(cards.filter((card) => !isCampaignCard(card)));

  return (
    <div className={styles.gridBase} id="categories">
      <div
        className={`${getCardsContainerGridColumnsClass(nonCampaigns.length)} ${styles.gridBase}`}
      >
        {nonCampaigns.map((card, index) => {
          if (isArray(card)) {
            return <SmallCardsGroup cards={card} key={`${card.length} ${index}`} />;
          } else {
            return <BigCard card={card} key={`${card.id} ${index}`} />;
          }
        })}
      </div>
      {campaigns && campaigns.length > 0 ? <Campaigns items={campaigns} /> : null}
    </div>
  );
});
